import React from "react";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { Divider } from "@material-ui/core";
// import useStyles from "../Payment/style";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import { fullDate } from "../../../utils/dateTime";
import currency from "../../../utils/currency";
import useCountDownTimer from "../../../components/useCountDownTimer";
import CopyToClipboard from "react-copy-to-clipboard";
import { useSnackbar } from "notistack";
import {
  ordersCollection,
  useData,
} from "../../../components/firebase/DataProvider";
import { useState } from "react";
import { useCollectionDataOnce } from "react-firebase-hooks/firestore";
import useStyles from "./style";
import { useHistory, useParams } from "react-router-dom";
import Header from "../../../components/molecules/Header";
import AppLoading from "../../../components/appLoading";
// import useStyles from "./style";

function Moota() {
  const classes = useStyles();
  const { integrasionPayments, profil } = useData();
  const { token } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  // const data = orders?.find((order) => order?.token === token && token !== "");
  const ordersRef = ordersCollection
    .where("order_info.owner_id", "==", profil.id)
    .where("token", "==", token);
  const [orders, loadingOrders] = useCollectionDataOnce(ordersRef, {
    idField: "id",
  });
  const thisMyOrderToPayment = orders?.[0];
  const dataBank = integrasionPayments?.find(
    (payment) =>
      payment?.id ===
        thisMyOrderToPayment?.transaction_info?.payment_type?.replace(
          "transfer_",
          ""
        ) &&
      thisMyOrderToPayment?.transaction_info?.payment_type?.replace(
        "transfer_",
        ""
      ) !== ""
  );
  const { timerArray } = useCountDownTimer(
    thisMyOrderToPayment?.expiration_date
  );
  const [openAtm, setOpenAtm] = useState(false);
  const [openMbanking, setOpenMbanking] = useState(false);

  // console.log(dataBank, thisMyOrderToPayment, token);
if (loadingOrders) {
  return <AppLoading/>
}
  return (
    <>
      <Header
        type="with-title"
        title="Pembayaran"
        onClick={() => history.goBack()}
      />
      <div className={classes.root}>
        <div className={classes.between}>
          <div>
            <Typography className={classes.liquidSmallGrey}>
              Batas Akhir Pembayaran
            </Typography>
            <Typography className={classes.liquidBold}>
              {fullDate(thisMyOrderToPayment?.expiration_date)}
            </Typography>
          </div>
          <div>
            <Typography color="secondary" className={classes.liquidBold}>
              {`${timerArray[0]}:${timerArray[1]}:${timerArray[2]}`}
            </Typography>
          </div>
        </div>
        <Divider />
        <div className={classes.between}>
          <div>
            <Typography className={classes.liquidSmallGrey}>
              Nomor Rekening
            </Typography>
            <Typography className={classes.liquidBold}>
              {dataBank?.account_number}
            </Typography>
          </div>
          <div style={{cursor:"pointer"}}>
            <CopyToClipboard
              text={dataBank?.account_number}
              onCopy={() => {
                enqueueSnackbar("Total pembayaran Berhasil Disalin", {
                  variant: "success",
                });
              }}
            >
              <Typography color="primary" className={classes.liquidBold}>
                Salin <FileCopyOutlinedIcon className={classes.liquidBold} />
              </Typography>
            </CopyToClipboard>{" "}
          </div>
        </div>
        <Divider />
        <div className={classes.between}>
          <div>
            <Typography className={classes.liquidSmallGrey}>
              Total Pembayaran
            </Typography>
            <Typography className={classes.liquidBold}>
              {currency(thisMyOrderToPayment?.total_pembayaran)}
            </Typography>
          </div>
          <div style={{cursor:"pointer"}}>
            <CopyToClipboard
              text={thisMyOrderToPayment?.total_pembayaran}
              onCopy={() => {
                enqueueSnackbar("Total pembayaran Berhasil Disalin", {
                  variant: "success",
                });
              }}
            >
              <Typography color="primary" className={classes.liquidBold}>
                Salin <FileCopyOutlinedIcon className={classes.liquidBold} />
              </Typography>
            </CopyToClipboard>
          </div>
        </div>
        <Divider style={{ height: "5px" }} />
        <div className={classes.between2}>
          <div>
            <Typography className={classes.liquidBold}>
              {dataBank?.account_name}
            </Typography>
          </div>
          <div>
            <img style={{ width: 50 }} src={dataBank?.logoUrl} alt="logo" />
          </div>
        </div>
        <Divider />
        <div style={{ padding: 10 }}>
          <div style={{ padding: 5 }}>
            <Typography className={classes.liquidGrey}>
              metode Pembayaran{" "}
            </Typography>
          </div>
          <div
            className={classes.between3}
            style={{ cursor: "pointer" }}
            onClick={() => {
              if (openAtm) {
                setOpenAtm(false);
                setOpenMbanking(false);
              } else {
                setOpenMbanking(false);
                setOpenAtm(true);
              }
            }}
          >
            <div>
              <Typography className={classes.liquidBold}>ATM</Typography>
            </div>
            <div> {openAtm ? <ExpandLessIcon /> : <ExpandMoreIcon />}</div>
          </div>
          <Divider />
          {openAtm ? (
            <>
              {dataBank?.instructions["atm"]?.map((item, index) => {
                const onColor = index % 2 == 0 ? true : false;

                return (
                  <div
                    style={{
                      backgroundColor: onColor ? "#ededed" : "white",
                      padding: 10,
                    }}
                  >
                    <Typography className={classes.liquid}>
                      {index + 1}. {item}
                    </Typography>
                  </div>
                );
              })}
            </>
          ) : null}
          <div
            className={classes.between3}
            style={{ cursor: "pointer" }}
            onClick={() => {
              if (openMbanking) {
                setOpenAtm(false);
                setOpenMbanking(false);
              } else {
                setOpenAtm(false);
                setOpenMbanking(true);
              }
            }}
          >
            <div>
              <Typography className={classes.liquidBold}>MBANKING</Typography>
            </div>
            <div> {openMbanking ? <ExpandLessIcon /> : <ExpandMoreIcon />}</div>
          </div>
          <Divider />
          {openMbanking ? (
            <>
              {dataBank?.instructions["mbanking"]?.map((item, index) => {
                const onColor = index % 2 == 0 ? true : false;

                return (
                  <div
                    style={{
                      backgroundColor: onColor ? "#ededed" : "white",
                      padding: 10,
                    }}
                  >
                    <Typography className={classes.liquid}>
                      {index + 1}. {item}
                    </Typography>
                  </div>
                );
              })}
            </>
          ) : null}
        </div>
      </div>
    </>
  );
}

export default Moota;
